import { useTranslation } from 'libs/i18n'
import { useToast } from 'shared/hooks'

export const useBookingData = () => {
	const { t } = useTranslation()

	const paymentMethod = [
		{
			value: 'external',
			label: t('External')
		},
		{
			value: 'verifone',
			label: t('Verifone')
		},
		{
			value: 'korta',
			label: t('Korta')
		},
		{
			value: 'rapyd',
			label: t('Rapyd')
		},
		{
			value: 'netgiro',
			label: t('Netgiro')
		}
	]

	const paymentStatus = [
		{
			value: 'init',
			label: t('Init')
		},
		{
			value: 'success',
			label: t('Success')
		},
		{
			value: 'pending',
			label: t('Pending')
		},
		{
			value: 'error',
			label: t('Error')
		},
		{
			value: 'canceled',
			label: t('Canceled')
		},
		{
			value: 'in_store',
			label: t('In store')
		}
	]

	const editBookingSuccessMsg = useToast({
		type: 'success',
		message: t('Booking updated')
	})

	const editBookingFailMsg = (message: string) => {
		return useToast({
			type: 'error',
			message: message ? message : t('Something went wrong')
		})
	}

	return {
		paymentMethod,
		paymentStatus,
		editBookingSuccessMsg,
		editBookingFailMsg
	}
}
